import { PaletteMode } from '@mui/material';
import { blue } from '@mui/material/colors';

export const light = {
  mode: 'light' as PaletteMode,
  primary: {
    main: '#536D85',
    contrastText: '#FFF1F0',
  },
  success: {
    main: '#9FCFFD',
    light: '#9AC0FA',
    dark: blue[600],
  },
  text: {
    primary: 'rgb(40, 40, 40)',
    secondary: 'rgb(103, 119, 136)',
  },
  background: {
    paper: '#FFF1F0',
    default: 'rgb(255, 255, 255)',
  },
  divider: 'rgba(0, 0, 0, 0.12)',
};

export const dark = {
  mode: 'dark' as PaletteMode,
  primary: {
    main: '#536D85',
    contrastText: '#FFF1F0',
  },
  warning: {
    main: '#9FCFFD',
    light: 'rgb(245, 205, 130)',
    dark: blue[600],
  },
  text: {
    primary: 'rgb(255, 255, 255)',
    secondary: 'rgb(207, 207, 207)',
  },
  background: {
    default: 'rgb(0, 0, 0)',
    paper: '#536D85',
  },
  divider: 'rgba(145, 158, 171, 0.24)',
};
